import { gql } from "@apollo/client";

export const GET_ACCESS_NOTIFCATIONS = gql`
  query ($startDate: String, $endDate: String, $accountId: Int) {
    accessRecords(data: { startDate: $startDate, endDate: $endDate, accountId: $accountId }) {
      id
      accessedBy
      account {
        id
        firstName
        lastName
      }
      source
      createdOn
      updatedOn
    }
  }
`;
